"use server";

import { z } from "zod";
import { sendMail } from "@/lib/mail";
import { staffEmails } from "@/lib/notifications";
import { prisma } from "@/lib/prisma";

export type ContactFormState = { error?: string; success?: boolean };

const schema = z.object({
  name: z.string().trim().min(2).max(120),
  email: z.string().trim().email(),
  message: z.string().trim().min(10).max(5000),
});

export async function submitContactAction(
  _prev: ContactFormState,
  formData: FormData,
): Promise<ContactFormState> {
  const parsed = schema.safeParse({
    name: formData.get("name"),
    email: formData.get("email"),
    message: formData.get("message"),
  });
  if (!parsed.success) {
    return { error: "invalid" };
  }

  const prospect = await prisma.prospect.create({
    data: {
      name: parsed.data.name,
      email: parsed.data.email,
      message: parsed.data.message,
      status: "NEW",
      source: "CONTACT_FORM",
    },
  });

  await prisma.auditEvent.create({
    data: {
      action: "contact.submit",
      entityType: "Prospect",
      entityId: prospect.id,
      metadata: {
        name: parsed.data.name,
        email: parsed.data.email,
      },
    },
  });

  const staff = await staffEmails();
  await sendMail({
    to: staff.length ? staff : parsed.data.email,
    subject: `[BE] Kontaktskjema fra ${parsed.data.name}`,
    text: `Navn: ${parsed.data.name}\nE-post: ${parsed.data.email}\n\n${parsed.data.message}\n\nInteressent: ${prospect.id}`,
  });

  return { success: true };
}
